export default "__VITE_ASSET__00cfecbe__"